import { ActivityTimelineCard } from '@paddl/storybook';
import { getActivityName, getContentfulFieldForEventId, getOrganisationName, urlStringForPathKey, getContentfulData } from '@paddl/utils-js';
import t from 'prop-types';
import React, { useEffect, useState } from 'react';
const getContentfulDataByEventId = async eventId => getContentfulData({
  content_type: 'paddlGames',
  'fields.eventId': eventId
});
export const AcitivityTimelineItem = _ref => {
  let {
    activity,
    isPublic
  } = _ref;
  const [title, setTitle] = useState(getActivityName(activity.details));
  const [subtitle, setSubtitle] = useState(getOrganisationName(activity.details));
  const activityUrl = isPublic ? urlStringForPathKey('publicActivitiesById', {
    id: activity.id
  }) : urlStringForPathKey('activitiesById', {
    id: activity.id
  });
  useEffect(() => {
    if (activity.variantId === 4) {
      getContentfulDataByEventId(activity.id).then(response => {
        const paddleGamesFields = getContentfulFieldForEventId(response.items, activity.details.eventId);
        if (paddleGamesFields) {
          setTitle(paddleGamesFields.name);
          setSubtitle(paddleGamesFields.hostCompany.title);
        } else {
          throw Error("Unable to find contentful data for event with id ".concat(activity.id));
        }
      });
    }
  });
  return /*#__PURE__*/React.createElement("a", {
    style: {
      textDecoration: 'none'
    },
    href: activityUrl,
    key: activity.id
  }, /*#__PURE__*/React.createElement(ActivityTimelineCard, {
    variantId: activity.variantId,
    title: title,
    subtitle: subtitle,
    xpNumber: activity.xpNumber,
    skills: activity.skillsCount,
    duration: activity.duration,
    percentageComplete: activity.percentageComplete
  }));
};
AcitivityTimelineItem.defaultProps = {
  isPublic: false
};
AcitivityTimelineItem.propTypes = {
  activity: t.shape({
    id: t.number,
    skillsCount: t.number,
    xpNumber: t.number,
    duration: t.shape({}),
    percentageComplete: t.number,
    variantId: t.number,
    details: t.shape({
      eventId: t.number
    })
  }).isRequired,
  isPublic: t.bool
};